import classNames from 'classnames';
import { ChatContext } from 'context/Context';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useEffect } from 'react';

const splitMessage = (message, search) => {
  const indexes = [];
  const phrases = [];

  let index = message.toLowerCase().indexOf(search.toLowerCase());

  while (index !== -1) {
    indexes.push(index);
    index = message.toLowerCase().indexOf(search.toLowerCase(), index + 1);
  }

  for (let i = 0; i < indexes.length; i++) {
    const currentIndex = indexes[i];

    let startIndex = currentIndex;
    let endIndex = currentIndex + search.length;

    // Find start index
    let countBackward = 0;
    while (countBackward < 3 && startIndex > 0) {
      startIndex--;
      if (message[startIndex] === ' ') {
        countBackward++;
      }
    }
    if (startIndex > 0 && message[startIndex] !== ' ') {
      startIndex++;
    }

    // Find end index
    let countForward = 0;
    while (countForward < 3 && endIndex < message.length) {
      endIndex++;
      if (message[endIndex] === ' ') {
        countForward++;
      }
    }
    if (endIndex < message.length && message[endIndex] !== ' ') {
      endIndex--;
    }

    phrases.push({ start: startIndex, end: endIndex });
  }

  // Merge overlapping phrases
  const mergedPhrases = [];
  let mergedStartIndex = -1;
  let mergedEndIndex = -1;

  for (let i = 0; i < phrases.length; i++) {
    const { start, end } = phrases[i];

    if (mergedStartIndex === -1) {
      mergedStartIndex = start;
      mergedEndIndex = end;
    } else if (start <= mergedEndIndex) {
      mergedEndIndex = Math.max(mergedEndIndex, end);
    } else {
      mergedPhrases.push({ start: mergedStartIndex, end: mergedEndIndex });
      mergedStartIndex = start;
      mergedEndIndex = end;
    }
  }

  if (mergedStartIndex !== -1) {
    mergedPhrases.push({ start: mergedStartIndex, end: mergedEndIndex });
  }

  // Build final phrases
  let finalPhrase = '';

  for (let i = 0; i < mergedPhrases.length; i++) {
    const { start, end } = mergedPhrases[i];

    if (i === 0 && start > 0) {
      finalPhrase += '...';
    }

    let phrase = message.slice(start, end + 1);

    if (i < mergedPhrases.length - 1) {
      const nextStart = mergedPhrases[i + 1].start;

      if (end < nextStart) {
        const nextWordIndex = message.indexOf(' ', end + 1) + 1;
        if (nextWordIndex !== -1 && nextWordIndex < nextStart) {
          const nextWord = message.slice(end + 1, nextWordIndex);
          phrase += nextWord;
        }
        phrase += '...';
      }
    }

    finalPhrase += phrase;

    if (i === mergedPhrases.length - 1 && end < message.length - 1) {
      finalPhrase += '...';
    }
  }

  const regex = new RegExp(search, 'gi');
  const markedString = finalPhrase.replace(regex, match => {
    return `<mark>${match}</mark>`;
  });

  return (
    <p
      className="mb-0"
      dangerouslySetInnerHTML={{
        __html: markedString
      }}
    />
  );
};
export const FindedMessages = ({ messages, search }) => {
  let lastDate;

  useEffect(() => {
    lastDate = null;
  }, [search]);

  const { setIsOpenConversationInfo, setScrollToMessage } =
    useContext(ChatContext);

  return (
    <div className="px-3 pb-2 d-flex flex-column gap-2">
      {messages.reverse().map((message, index) => {
        const { created_at } = message;
        const time = dayjs(created_at);
        const user = message.user || message.client;
        const fullName = `${user.firstName} ${user.lastName}`;

        return (
          <div
            key={index}
            className="no-selectable cursor-pointer"
            onClick={() => {
              setIsOpenConversationInfo(false);
              setScrollToMessage(message.id);
            }}
          >
            {lastDate !== time.format('DD/MM/YYYY') && (
              <div
                className={classNames('text-center fs--2 text-500', {
                  'mt-2': index !== 0
                })}
              >
                {time.format('DD/MM/YYYY, HH:mm')}
              </div>
            )}
            {(() => {
              lastDate = time.format('DD/MM/YYYY');
            })()}

            <div
              className={classNames('p-2 rounded-2 chat-message w-100', {
                'bg-200': !!message.client,
                'bg-primary text-white light': !!message.user
              })}
              style={{ maxWidth: 'none' }}
            >
              {message.message &&
                search &&
                splitMessage(message.message, search)}
            </div>

            <div className="text-400 fs--2 text-end">
              <span className="font-weight-semi-bold me-2">{fullName}</span>

              {time.format('HH:mm')}
            </div>
          </div>
        );
      })}
    </div>
  );
};
FindedMessages.propTypes = {
  messages: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
  closeThreadInfo: PropTypes.func.isRequired,
  scrollToMessage: PropTypes.func.isRequired
};
